/**
 * External dependencies
*/

import { useEffect, useState } from '@wordpress/element';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { __ } from '@wordpress/i18n';
import { getSetting } from '@woocommerce/settings';
import { decodeEntities } from '@wordpress/html-entities';
import { dispatch } from '@wordpress/data';

const settings = getSetting('bitpay-payment_data', {});
const defaultLabel = __('Bit', 'meshulam-payment-gateway');
const label = decodeEntities(settings.title) || defaultLabel;
const { CHECKOUT_STORE_KEY } = window.wc.wcBlocksData;
let currentOrderId = '';

const Content = (props) => {
    const { eventRegistration, emitResponse } = props;
    const { onCheckoutSuccess } = eventRegistration;

    useEffect(() => {
        const unsubscribe = onCheckoutSuccess(async () => {
            try {

                if (!currentOrderId) {
                    console.error("orderId is missing");
                    return;
                }

                const response = await fetch(settings.ajax_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({
                        order_id: currentOrderId,
                        action: "meshulam_popup_payment_iframe"
                    })
                });

                const result = await response.text();

                if (!result || result === 'false') {
                    return {
                        type: emitResponse.responseTypes.ERROR,
                        message: 'There was an error',
                    };
                }

                document.body.insertAdjacentHTML('beforeend', result);

                const closePopup = document.querySelector(".close_popup_meshulam");
                if (closePopup) {
                    closePopup.style.display = 'block';
                    setTimeout(() => {
                        closePopup.style.opacity = 1;
                    }, 6000);
                }


            } catch (error) {
                console.error("Error:", error);
            }
        });

        // Unsubscribes when this component is unmounted.
        return () => {
            unsubscribe();
        };
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        onCheckoutSuccess,
        currentOrderId
    ]);

    useEffect(() => {
        window.addEventListener('message', function (result) {
            if (result.origin === 'https://meshulam.co.il' || result.origin === 'https://sandbox.meshulam.co.il' || result.origin === 'https://secure.meshulam.co.il') {
                switch (result.data.action) {
                    case 'close': {
                        document.querySelectorAll('.popup_overlay_meshulam').forEach(el => el.remove());
                        unblockBlockCheckout();
                        break;
                    }
                    case 'payment': {
                        if (result.data.status == 1) { }
                        break;
                    }
                    case 'failed_to_load_page': {
                        if (settings.fail_url) {
                            window.top.location.href = settings.fail_url + '?order_error=failer&order_id=' + orderId;
                        } else {
                            window.top.location.href = settings.checkout_url;
                        }
                        break;
                    }
                    case 'bit_cancel': {
                        document.querySelectorAll('.popup_overlay_meshulam').forEach(el => el.remove());
                        unblockBlockCheckout();
                        break;
                    }
                }
            }
        });
    }, []);

    useEffect(() => {
        const originalFetch = window.fetch;
        window.fetch = async function (...args) {
            const response = await originalFetch(...args);
            const clonedResponse = response.clone();
            if (args[0].includes('/wp-json/wc/store/v1/checkout')) {
                try {
                    const data = await clonedResponse.json();
                    if (data.order_id) {
                        currentOrderId = data.order_id;
                    }
                } catch (error) {
                }
            }
            return response;
        };

        return () => {
            window.fetch = originalFetch;
        };
    }, []);

    return <div>{decodeEntities(settings.description || '')}</div>;
}

const unblockBlockCheckout = () => {
    if (typeof wcSettings === 'undefined' || !wcSettings.wcBlocksConfig) {
        return;
    }

    const checkoutStore = dispatch(CHECKOUT_STORE_KEY);
    checkoutStore.__internalSetRedirectUrl(null);
    checkoutStore.__internalSetIdle();

    const { PAYMENT_STORE_KEY } = window.wc.wcBlocksData;
    dispatch(PAYMENT_STORE_KEY).__internalSetPaymentIdle();
}

const Icon = () => {
    return settings.icon ? <img src={settings.icon} /> : '';
}

const Label = () => {
    return (
        <span className="icon_label">
            <span>{label}</span>
            <Icon />
        </span>
    );
}

const bitPaymentMethod = {
    name: settings.name,
    label: <Label />,
    placeOrderButtonLabel: settings.button_title,
    content: <Content />,
    edit: <Content />,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports ?? [],
    },
}

registerPaymentMethod(bitPaymentMethod);